import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Tabs,
  Tab,
  Paper,
  alpha,
  useTheme,
} from "@mui/material";
import {
  GpsFixed as GpsIcon,
  Settings as SettingsIcon,
  Notifications as NotificationsIcon,
  Security as SecurityIcon,
} from "@mui/icons-material";
import GeofenceSettings from "../../components/SystemSettings/GeofenceSettings";

const SettingsScreen = () => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState("geofencing");

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          mb: 2.5,
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "10px",
            bgcolor: alpha(theme.palette.primary.main, 0.08),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <SettingsIcon sx={{ color: "#2469F0", fontSize: 22 }} />
        </Box>
        <Box>
          <Typography variant="h5" fontWeight={700} color="#1A1A2E">
            System Settings
          </Typography>
          <Typography variant="body2" color="#6B7280">
            Manage system configurations and preferences
          </Typography>
        </Box>
      </Box>

      <Paper
        elevation={0}
        sx={{
          borderRadius: "12px",
          border: "1px solid #E2E8F0",
          overflow: "hidden",
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            bgcolor: "#F8FAFC",
            borderBottom: "1px solid #E2E8F0",
            minHeight: 48,
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.8rem",
              py: 1.25,
              px: 2.5,
              minHeight: 48,
              color: "#64748B",
              "&.Mui-selected": {
                color: "#2469F0",
              },
            },
            "& .MuiTabs-indicator": {
              height: 3,
              borderRadius: "3px 3px 0 0",
              bgcolor: "#2469F0",
            },
          }}
        >
          <Tab
            label="Geofencing"
            icon={<GpsIcon sx={{ fontSize: 18 }} />}
            iconPosition="start"
            value="geofencing"
          />
          <Tab
            label="General"
            icon={<SettingsIcon sx={{ fontSize: 18 }} />}
            iconPosition="start"
            value="general"
            disabled
          />
          <Tab
            label="Notifications"
            icon={<NotificationsIcon sx={{ fontSize: 18 }} />}
            iconPosition="start"
            value="notifications"
            disabled
          />
          <Tab
            label="Security"
            icon={<SecurityIcon sx={{ fontSize: 18 }} />}
            iconPosition="start"
            value="security"
            disabled
          />
        </Tabs>

        <Box sx={{ p: 2.5 }}>
          {activeTab === "geofencing" && <GeofenceSettings />}
          {activeTab === "general" && (
            <Box sx={{ textAlign: "center", py: 4 }}>
              <Typography color="text.secondary">General settings coming soon</Typography>
            </Box>
          )}
          {activeTab === "notifications" && (
            <Box sx={{ textAlign: "center", py: 4 }}>
              <Typography color="text.secondary">Notification settings coming soon</Typography>
            </Box>
          )}
          {activeTab === "security" && (
            <Box sx={{ textAlign: "center", py: 4 }}>
              <Typography color="text.secondary">Security settings coming soon</Typography>
            </Box>
          )}
        </Box>
      </Paper>
    </Container>
  );
};

export default SettingsScreen;